import { fmtPHP } from "@/lib/api";
import { BadgeCheck, ShieldAlert } from "lucide-react";

export const PCard = ({ children, className = "", ...rest }) => (
  <div className={`${/\bbg-/.test(className) ? "" : "bg-white border border-slate-200/80"} rounded-2xl shadow-sm p-4 ${className}`} {...rest}>
    {children}
  </div>
);

export const SectionTitle = ({ children, action }) => (
  <div className="flex items-center justify-between mb-3 mt-6">
    <h2 className="font-display font-bold text-slate-900 text-base">{children}</h2>
    {action}
  </div>
);

const ratingFor = (s) => (s >= 700 ? "EXCELLENT" : s >= 600 ? "GOOD" : s >= 450 ? "FAIR" : "BUILDING");

export function CreditBadge({ score, available, scoreIsDefault = false, creditIsDefault = false }) {
  return (
    <div data-testid="credit-score-badge"
      className="portal-badge relative w-56 h-56 mx-auto rounded-full flex flex-col items-center justify-center bg-gradient-to-b from-emerald-50 to-white border-[10px] border-emerald-500 shadow-[0_0_40px_rgba(16,185,129,0.35)]">
      <span className="text-[11px] font-bold tracking-[0.2em] uppercase text-emerald-600">Credit Score</span>
      <span className="font-display text-5xl font-extrabold text-slate-900 tracking-tight" data-testid="credit-score-value">
        {score}
      </span>
      <span data-testid="credit-score-rating" className={`mt-1 px-3 py-0.5 rounded-full text-[10px] font-bold ${scoreIsDefault ? "bg-amber-100 text-amber-800" : "bg-emerald-100 text-emerald-800"}`}>
        {scoreIsDefault ? "DEFAULT · UNVERIFIED" : ratingFor(score)}
      </span>
      <span data-testid="available-credit-label" className="text-xs text-slate-500 mt-3">{creditIsDefault ? "Default credit · not approved" : "Available Credit"}</span>
      <span className="font-display text-lg font-bold text-emerald-700" data-testid="available-credit-value">
        {fmtPHP(available)}
      </span>
    </div>
  );
}

export function VerifiedPill({ verified }) {
  return verified ? (
    <span data-testid="verified-status-badge"
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-emerald-50 text-emerald-700 border border-emerald-200">
      <BadgeCheck className="h-3.5 w-3.5" /> Verified Account
    </span>
  ) : (
    <span data-testid="verified-status-badge"
      className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold bg-amber-50 text-amber-700 border border-amber-200">
      <ShieldAlert className="h-3.5 w-3.5" /> Verification pending
    </span>
  );
}

const PILL = {
  Pending: "bg-amber-50 text-amber-700",
  "Under Review": "bg-blue-50 text-blue-700",
  Approved: "bg-emerald-50 text-emerald-700",
  Rejected: "bg-rose-50 text-rose-700",
  Disbursed: "bg-cyan-50 text-cyan-700",
  Active: "bg-blue-50 text-blue-700",
  "Fully Paid": "bg-slate-100 text-slate-700",
  Overdue: "bg-red-50 text-red-700",
  Paid: "bg-emerald-50 text-emerald-700",
  Partial: "bg-amber-50 text-amber-700",
  Scheduled: "bg-slate-100 text-slate-600",
};

export const StatusPill = ({ status }) => (
  <span className={`px-2 py-0.5 rounded-full text-[11px] font-semibold ${PILL[status] || "bg-slate-100 text-slate-600"}`}>
    {status}
  </span>
);
